module.exports = __webpack_public_path__ + "img/graph_1.e60ff299.svg";